import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Divider, Input, Radio, Select } from 'antd';
import "./detail.scss";
import { useSurveyRespond } from '../../../../../../../../../stores/stores';

const { Option } = Select;

const QuestionType4 = (props: any) => {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const [isOtherSelected, setIsOtherSelected] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>("");

  const handleSelectChange = (value: any) => {
    setSelectedOption(value);
    setIsOtherSelected(false);
  };

  const handleOtherSelected = () => {
    setIsOtherSelected(true);
    setSelectedOption(null);
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  }

  const [maxWidth, setMaxWidth] = useState(0);

  useEffect(() => {
    const tempDiv = document.createElement('div');
    tempDiv.style.display = 'inline-block';
    tempDiv.style.visibility = 'hidden';
    document.body.appendChild(tempDiv);

    let maxWidthTemp = 0;

    props.listOptions.forEach((option: any) => {
      tempDiv.innerText = option.answerText;
      maxWidthTemp = Math.max(maxWidthTemp, tempDiv.offsetWidth);
    });

    setMaxWidth(maxWidthTemp);
    document.body.removeChild(tempDiv);
  }, [props.listOptions]);

  return (
    <div >
      <Select
        placeholder={t("Lựa chọn đáp án", "Lựa chọn đáp án")}
        dropdownStyle={{ width: maxWidth + 32 }}
        style={{ width: "100%", marginBottom: "15px"}}
        onChange={handleSelectChange}
        value={selectedOption}
        showSearch
        allowClear
        filterOption={(input, option) =>
          ((option?.children as unknown) as string)?.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        disabled={props.typeSurvey === "2"}
      >
        {props.listOptions.map((option: any) => (
          <Option key={option.answerId} value={option.answerId}>
            {option.answerText}
          </Option>
        ))}
      </Select>
      {
        props.listOptions.map((Option: any) => (
          Option.isOther ? (
            <>
              <Radio
                checked={isOtherSelected}
                onChange={handleOtherSelected}
                disabled={props.typeSurvey === "2"}
              >{t("Khác", "Khác")}</Radio>
              {isOtherSelected && (
                <>
                  <Input
                    placeholder={t("Vui lòng nhập...", "Vui lòng nhập...")}
                    value={inputValue}
                    onChange={handleChangeInput}
                    style={{ marginTop: "12px", marginBottom: "12px" }}
                    disabled={props.typeSurvey === "2"}
                  />
                </>
              )}
              {!isOtherSelected && <Divider style={{ margin: "12px 0" }} />}
            </>
          ) : null
        ))
      }
    </div>
  );
};

export default QuestionType4;

